import MuiSnackbar, { SnackbarProps } from '@mui/material/Snackbar';
import MuiSnackbarContent, {
  SnackbarContentProps,
} from '@mui/material/SnackbarContent';

export const Snackbar = ({ ...props }: SnackbarProps) => (
  <MuiSnackbar {...props} />
);

export const SnackbarContent = ({ ...props }: SnackbarContentProps) => (
  <MuiSnackbarContent {...props} />
);
